import defaultColor from "@/components/color";

export default {
    attribute: {
        defaultValueType: null,defaultValue: '',
        num:{color: defaultColor[2], fontSize:50, fontFamily:'lccd'},
        label:{color: '#ddd', fontSize:16, align: 'top'},
        direction:1,targetTime:'2022-11-08 12:00:02',
        accuracy:5,
        showYear:true
    },
}
